import {topNavigationMenuItemAPI} from '../../../../api/topNavigationMenuAPI';
import TopNavigationMenuItem from '../../../../api/topNavigationMenuEntity';
import { actionTypes } from '../../../constants/actionTypes';

import { httpCallStartAction } from '../../../../middlewares/http/actions';

export const fetchTopNavigationMenuItemAction = () => (dispatch: any) => {
  dispatch(httpCallStartAction());

  topNavigationMenuItemAPI.fetchTopNavigationMenuItemAsync()
    .then((menuItems) => {
      dispatch(fetchTopNavigationMenuItemCompleted(menuItems));
    });
};

const fetchTopNavigationMenuItemCompleted = (menuItems: TopNavigationMenuItem[]) => ({
  meta: {
    httpEnd: true,
  },
  payload: menuItems,
  type: actionTypes.FETCH_TOP_NAVIGATION_COMPLETED
});

export const toggleMobileNavigationMenuAction = () => ({
      type: actionTypes.MOBILE_NAVIGATION_CLICKED
});

export const updateTopNavigationMenuItemStateAction = (subMenuItem: TopNavigationMenuItem) => ({
  payload: subMenuItem,
  type: actionTypes.UPDATE_MOBILE_SUB_NAVIGATION
});

export const setTopNavigationActiveStateAction = (navigationUrl: string) => ({
  payload: navigationUrl,
  type: actionTypes.SET_TOP_NAVIGATION_ACTIVE_CSS
});


// WEBPACK FOOTER //
// ./src/common/components/topNavigation/actions/fetchTopNavigationMenuItems.ts